export const isMigratedEditorEnabled = (country: string | undefined) => {
  return process.env.REACT_APP_INSTANT_FORM_NEXTJS_MIGRATION_ENABLED === 'true';
};
